(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../colors', '../fonts/fonts'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../colors'), require('../fonts/fonts'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.colors, global.fonts);
    global.peachjarPortal = mod.exports;
  }
})(this, function (exports, _colors, _fonts) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var portalTheme = {
    primaryTone: _colors2.default.platinum,
    secondaryTone: _colors2.default.white,
    primaryFont: _fonts.ProximaNova
  };

  exports.default = portalTheme;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/styles/themes/peachjar-portal.js
// module id = 1562
// module chunks = 1